import { render, staticRenderFns } from "./obmen_i_vozvrat.vue?vue&type=template&id=3b81adf2&"
import script from "./obmen_i_vozvrat.vue?vue&type=script&lang=js&"
export * from "./obmen_i_vozvrat.vue?vue&type=script&lang=js&"
import style0 from "./obmen_i_vozvrat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b81adf2')) {
      api.createRecord('3b81adf2', component.options)
    } else {
      api.reload('3b81adf2', component.options)
    }
    module.hot.accept("./obmen_i_vozvrat.vue?vue&type=template&id=3b81adf2&", function () {
      api.rerender('3b81adf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/obmen_i_vozvrat.vue"
export default component.exports